import { useEffect } from 'react'

import { roomKeys } from 'helpers/events'

export default function useHandleOnDisconnect(room, onDisconnect) {
    useEffect(() => {
        room.addListener(roomKeys.DISCONNECTED, onDisconnect)

        return () => {
            room.removeListener(roomKeys.DISCONNECTED, onDisconnect)
        }
    }, [room, onDisconnect])
}
